import React from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { REDIRECT_TO_LOGIN } from './auth';

const AuthenticatedRoute = ({
  authCheckComplete,
  authenticated,
  redirectToLogin,
  ...rest,
}) => {
  authCheckComplete && !authenticated && redirectToLogin();

  return (<Route {...rest}  />);
}

const mapStateToProps = state => ({
  authCheckComplete: state.user.authCheckComplete,
  authenticated: state.user.isAuthenticated,
});

const mapDispatchToProps = dispatch => ({
  redirectToLogin: () => dispatch({ type: REDIRECT_TO_LOGIN }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthenticatedRoute);


// WEBPACK FOOTER //
// ./src/_app/auth/AuthenticatedRoute.jsx